export default __webpack_public_path__ + "static/media/Lozenge 2.e4dffad8.png";